// for web (which doesn't use splash screen) / make typescript happy
export const SplashScreen = {
  hide: async () => Promise.resolve(),
  getHideSplashPreInit: () => false,
};
